export function phoneSelector(state) {
  return state.social.phone || '';
}